// extracted by mini-css-extract-plugin
export var horizontal = "checkbox-group-module--horizontal--5a19f";
export var optionWrapper = "checkbox-group-module--optionWrapper--47181";
export var options = "checkbox-group-module--options--df082";
export var tooltipTrigger = "checkbox-group-module--tooltipTrigger--44cbd";
export var vertical = "checkbox-group-module--vertical--304c7";